export default {"src":"/_next/static/media/swimming-pool.43ce0a5c.svg","height":116,"width":116,"blurWidth":0,"blurHeight":0};